import React from 'react';
import { X, Plus, Minus} from 'lucide-react';

const Cart = ({ items, updateQuantity, removeItem, totalAmount }) => {
  return (
    <div className="bg-primary-lighter p-4 rounded-lg shadow-md">
      <h2 className="text-xl font-bold mb-4">Shopping Cart</h2>
      {items.length === 0 ? (
        <p>Your cart is empty</p>
      ) : (
        <>
          {/* Add max-h-[60vh] for vertical scrolling and overflow-y-auto for scrollbar */}
          <div className="max-h-[60vh] overflow-y-auto pr-2">
            {items.map(item => (
              <div key={`${item.id}-${item.selectedSize.size}`} className="flex items-center py-4 border-b">
                <img 
                  src={item.image} 
                  alt={item.name}
                  className="w-16 h-16 object-cover rounded-md"
                />
                <div className="ml-4 flex-grow">
                  <h3 className="font-semibold">{item.name}</h3>
                  <p className="text-sm text-gray-500">Size: {item.selectedSize.size}</p>
                  <p className="text-gray-600">₦{item.selectedSize.price}</p>
                  <div className="flex items-center mt-2">
                    <button 
                      onClick={() => updateQuantity(item.id, item.selectedSize.size, item.quantity - 1)}
                      className="p-1 rounded-md hover:bg-gray-100"
                      disabled={item.quantity <= 1}
                    >
                      <Minus className="w-4 h-4" />
                    </button>
                    <span className="mx-4">{item.quantity}</span>
                    <button 
                      onClick={() => updateQuantity(item.id, item.selectedSize.size, item.quantity + 1)}
                      className="p-1 rounded-md hover:bg-gray-100"
                    >
                      <Plus className="w-4 h-4" />
                    </button>
                  </div>
                </div>
                <button 
                  onClick={() => removeItem(item.id, item.selectedSize.size)}
                  className="p-1 rounded-md hover:bg-gray-100"
                >
                  <X className="w-4 h-4" />
                </button>
              </div>
            ))}
          </div>
          <div className="mt-4">
            <p className="text-xl font-bold">Total: ₦{totalAmount.toFixed(2)}</p>
          </div>
        </>
      )}
    </div>
  );
};

export default Cart;